import axiosInstance from "../../../utils/axios";


const path = "/waiter/menu";



export const categoryList = async (values,option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).post(`${path}/categories/list`, values);
}

export const subCategoryList = async (values,option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).post(`${path}/sub-categories/list`, values);
}


export const categoryDetail = async (values,option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).post(`${path}/categories/details` , values);
}

export const menuItemList = async (values,option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).post(`${path}/items/list`, values);
}


export const menuItemDetail = async (values,option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).post(`${path}/items/details` , values);
}

export const cashRegisterData = async (values,option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).get(`${path}/cash-register-details?restaurant_id=${values._id}` );
}

export const spiceLevelsOptions = async (values,option) => {
  return await axiosInstance({
    suppressUnauthorizedHandling: true,
    extraHeaders: {authorization:`Bearer ${option.token}`, "x-bypass-origin":"true"}
  }).get(`${path}/spice-levels-options`, values);
}
